// Personas (_PERSONA- block) — persisted in localStorage.
// Même pattern que categories.js. Valeurs slug-safe : elles finissent dans le
// nom de fichier d'export, donc lowercase sans espace ni underscore.
// Défauts alignés sur PERSONA_OPTS d'ExportTab.js (broad/benny/samir/emiko).
const LS_KEY = 'timbo_personas_v1';

const DEFAULT_PERSONAS = ['broad', 'benny', 'samir', 'emiko'];

export function getPersonas() {
  try {
    const saved = JSON.parse(localStorage.getItem(LS_KEY));
    return saved && saved.length ? saved : [...DEFAULT_PERSONAS];
  } catch { return [...DEFAULT_PERSONAS]; }
}

export function savePersonas(list) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(list)); } catch {}
}

export function sanitizePersona(v) {
  return (v || '').trim().toLowerCase().replace(/[^a-z0-9-]/g, '');
}

export default DEFAULT_PERSONAS;
